import { render, staticRenderFns } from "./DeptEdit.vue?vue&type=template&id=3e0821fc&scoped=true&"
import script from "./DeptEdit.vue?vue&type=script&lang=js&"
export * from "./DeptEdit.vue?vue&type=script&lang=js&"
import style0 from "./DeptEdit.vue?vue&type=style&index=0&id=3e0821fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0821fc",
  null
  
)

export default component.exports